module.exports = __webpack_public_path__ + "static/assets/42a6a87881e09ba1de82f542d390eecb.svg";